<template>
  <div class="form-group form-group--text" :class="getClass()">
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <div class="input-group" v-if="component.suffix || component.prefix">
          <span class="input-group-addon" v-if="component.prefix">{{ component.prefix }}</span>
          <!--Foi alterado o disabled para readonly por motivo de validação com regex-->
          <the-mask class="form-control"
                    :id="component.key"
                 :type="component.type"
                 :name="component.key"
                 :readonly="disabledHandler()"
                 :placeholder="component.placeholder"
                 :minLength="component.validate.minLength"
                 :maxLength="component.validate.maxLength"
                 :mask="component.inputMask"
                 :masked="false"
                 v-validate="setRules()"
                 :data-vv-name="component.key"
                 :value="component.data.currentValue"
                 v-model="component.data.currentValue"
                 @focus.native="focusHandler()"
                 @blur.native="blurHandler()"
                 @keyup.13.native="enterHandler()"></the-mask>
          <span class="input-group-addon" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
        <!--Foi alterado o disabled para readonly por motivo de validação com regex-->
        <the-mask class="form-control"
                  :id="component.key"
               :type="component.type"
               :name="component.key"
               :readonly="disabledHandler()"
               :placeholder="component.placeholder"
               :minLength="component.validate.minLength"
               :maxLength="component.validate.maxLength"
               v-validate="setRules()"
               :mask="component.inputMask"
               :masked="false"
               :data-vv-name="component.key"
               :value="component.data.currentValue"
               v-model="component.data.currentValue"
               @focus.native="focusHandler()"
               @blur.native="blurHandler()"
               @keyup.13.native="enterHandler()"
               v-else></the-mask>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g id="form_icon_error_alert" transform="translate(-252 -635)">
              <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ (errors.first(component.key)) }}
        </span>
        <span class="help-block help-block--bottom" v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

// Utils
import { TheMask } from '@/directives/mask'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  components: {
    TheMask
  },
  name: 'component-text',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false
    }
  },
  created () {
    this.setValue()
  }
}
</script>
